module.exports = __webpack_public_path__ + "static/assets/2a91a28ac6f9f37e41f37f9f09764a31.svg";